import { Geometry } from 'geojson';
import { LocationType } from './location-type';
import { IConnectedService } from '../customers';
import { ILocationCustomerLookupValue } from './location-customer-lookup-value';

export interface ILocation {
  id: number;
  uniqueId: string;
  name: string;
  enabled: boolean;
  type: LocationType;
  customer?: ILocationCustomerLookupValue;
  address: string;
  geometry: Geometry;
  capacity?: number;
  timezone?: string;
  settings?: ILocationSettings;
  connectedServices: IConnectedService[];
}

export interface ILocationSettings {
  garageSettings?: IGarageSettings;
}

export interface IGarageSettings {
  floors: number;
}

export interface ILocationsStatistic {
  totalLocations: number;
  activeLocations: number;
  activeBillableLocations: number;
  currentMonthLocationsToInvoice: number;
  totalLanes: number;
  enabledLanes: number;
  currentMonthTotalCalls: number;
  currentMonthTotalDuration: number;
  locationsAddedThisMonth: number;
  locationsDeactivatedThisMonth: number;
  currentMonthTotalAgents: number;
  currentMonthActiveAgents: number;
  previousMonthTotalAgents: number;
  previousMonthActiveAgents: number;
}

export interface IVoicePlatformAccessStatistic {
  currentMonthMobileAccess: number;
  previousMonthMobileAccess: number;
  currentMonthVoicePlatformUsers: number;
  previousMonthVoicePlatformUsers: number;
}

export function newLocation(): ILocation {
  return {
    id: 0,
    uniqueId: '',
    name: '',
    enabled: false,
    type: LocationType.ParkingLot,
    customer: undefined,
    address: '',
    geometry: {
      type: 'Point',
      coordinates: [0, 0],
    },
    connectedServices: [],
  } as ILocation;
}
